<template>
  <!-- 最新发布 -->
  <div class="release">
    <div class="line" v-show="tablesName"></div>
    <div class="show-box" v-if="tablesName">
      <router-link tag="a"
                   :to="{name:'Find'}" style="text-decoration: none">
        <h5 class="show-tit">
          {{tablesTitle}}
          <a href="javascript:void(0);" class="show-linkmore">更多</a>
        </h5>
      </router-link>
      <div class="swiper-container show-poll-swiper show-id-swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(v,ind) in tablesName">
            <ul class="show-list">
              <li class="dbroadcast" v-for="(val,i) in twoNumbers" :attr-item="JSON.stringify(tables[ind*2+i])"
                  attr-type="tablesName">
                <a href="javascript:void(0);">
                  <div class="show-remd-logo" v-if="tables[ind*2+i].hostunit">
                    <img :src="tables[ind*2+i].hostunit.host_avatar" alt=""/>
                  </div>
                  <div class="show-remd-tit" v-if="tables[ind*2+i].hostunit">
                    {{tables[ind*2+i].hostunit.column_name}}
                  </div>
                  <div class="pic-box" v-if="tables[ind*2+i].playbill">
                    <img :src="tables[ind*2+i].playbill.playbill_small || tables[ind*2+i].playbill.playbill"
                         alt=""/>
                    <!--  <i class="icon-time">01.02</i>-->
                  </div>
                  <p>{{tables[ind*2+i].title}}</p>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "release",
    props: [
      "detailsTxte",
      "twoNumbers",
    ],
    data() {
      return {
        tablesName: '',
        tables: '',
        tablesTitle: '',
      }
    },
    methods: {
      // 操作按钮事件
    },
    created: function () {
      var that = this;
      var pageConfig = that.detailsTxte.page_config;
      var id = this.$route.params.id;
      if (pageConfig &&　pageConfig.popular && pageConfig.popular.is_show == 1) {
        //GetActivities
        that.$http.get(API.GetActivities, {
          params: {
            progress: 'on',
            page: 1,
            pagesize: 6,
            version: 2
          }
        }).then(function (res) {
          if (res.code == '0') {
            that.tablesTitle = pageConfig.popular.title;
            that.tablesName = Math.floor(res.data.length / 2);
            that.tables = res.data;
            //console.log(res.data)
            that.$nextTick(function () {
              var picWimg = $('.pic-box').width();
              var picHimg = Math.ceil($('.pic-box').width() / 16 * 9);
              $('.pic-box img').css({width: picWimg, height: picHimg, visibility: 'visible'});

              var swiperPoll = new Swiper('.show-poll-swiper', {
                loop: true,
                autoplayDisableOnInteraction: false
              });
            });
          }
        });
      } else {
        $('#hotActivity').hide()
      }
    },
    mounted: function () {
      // 操作DOM
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/detailtmplate/release.vue